import { createApi } from '@reduxjs/toolkit/query/react';
import { apiQuery } from '../../utils/api-config';
import { ApiResponse, Employee, EmployeeDetail, EmployeeLog, PaginatedResponse, SearchEmployeeRequest } from '../../types/employee.type';



export const employeeApi = createApi({
    reducerPath: 'employeeApi',
    baseQuery: apiQuery,
    endpoints: (builder) => ({
        getSearchEmployees: builder.query<ApiResponse<PaginatedResponse<Employee>>, SearchEmployeeRequest>({
            query: (body) => ({
                url: '/employee/search',
                method: 'POST',
                body,
            }),
        }),
        getEmployeeDetail: builder.query<ApiResponse<EmployeeDetail>, number>({
            query: (id) => ({
                url: `/employee/detail/${id}`,
                method: 'GET',
            }),
        }),
        getEmployeeLogs: builder.query<ApiResponse<EmployeeLog[]>, number>({
            query: (id) => ({
                url: `/employee/logs/${id}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useLazyGetSearchEmployeesQuery,
    useGetEmployeeDetailQuery,
    useGetEmployeeLogsQuery,
} = employeeApi;
